































import { defineComponent, PropType } from '@vue/composition-api';
import AtomLabel from '@/components/atoms/AtomLabel.vue';

import { useAdvisorSearchRecommendedKeywords } from '@/modules/advisor-search/organisms/AdvisorSearchRecommendedKeywords';
import { recommendedCategories } from '@/modules/advisor-search/organisms/AdvisorSearchRecommendedKeywords';

export default defineComponent({
  name: 'AdvisorSearchRecommendedKeywords',
  components: {
    AtomLabel,
  },
  props: {
    recommendedKeywords: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  setup() {
    const { path, onClick } = useAdvisorSearchRecommendedKeywords(false);
    return {
      path,
      onClick,
      recommendedCategories,
    };
  },
});
